module.exports = require('./helpers/bundle-url').getBundleURL('5CuLX') + "logo.c51670a8.svg";